angular.module("ainapp")
    .controller("workTypeController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Work Type";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {
                $scope.Shift = {
                    Name: "",
                }

                $scope.load = 0;
            }
            $scope.Init();

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.WorkTypeInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },
                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "Name",
                        title: "Grade",
                        headerTemplate: "{{LanguageData.Name}}",

                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                    },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteWorkType($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success($scope.LanguageData.Deleted);
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }


            $scope.Edit = function (data) {
                $scope.Shift = data;
                //$scope.$apply();
            }




            $scope.AddData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.Shift.Id > 0) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToAddData);
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.Shift.Id > 0) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToEditData);
                } else if ($scope.Shift.Name == "") {
                    toastr.warning($scope.LanguageData.EntertheGrade);

                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddWorkType($scope.Shift).then(function (response) {
                        if (response.data) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success($scope.LanguageData.Success);
                            $scope.Init();
                        } else {
                            toastr.error($scope.LanguageData.Error);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }

                }])
